import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import type { CustomerStopDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';
import { GATEWAY_TIMEOUT_STATUS_CODE } from '../recoil/types/types';
import { refreshExternalCasesAtom } from '../recoil/atoms/refreshExternalCasesAtom';
import axios from 'axios';
import { useErrorBoundary } from 'react-error-boundary';

export function useQuoteJob(): {
    quoteJob: () => Promise<CustomerStopDTO>;
} {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const refreshExternalCases = useSetRecoilState(refreshExternalCasesAtom);
    const { showBoundary } = useErrorBoundary();

    const quoteJob = async (): Promise<CustomerStopDTO> => {
        refreshExternalCases({});
        return await OnlineSales.quoteJob(jobNumber, sessionId).catch(async (err) => {
            if (axios.isAxiosError(err) && err.response?.status !== GATEWAY_TIMEOUT_STATUS_CODE)
                showBoundary(err);
            return await Promise.resolve({ stopCause: 'None' });
        });
    };

    return { quoteJob };
}
